const PRIMARY_COLOR = '#005DFF';
const PRIMARY_RGB = 'rgb(0 93 255 / !@#$%)';
const SECONDARY_COLOR = '#005DFF';
const BACKGROUND_COLOR = '#F0F6FE';

const lightTheme = {
    primaryColor: PRIMARY_COLOR,
    secondaryColor: SECONDARY_COLOR,
    backgroundColor: BACKGROUND_COLOR,
    primaryRgb: opacity => PRIMARY_RGB.replace('!@#$%', opacity),
}

export default lightTheme;